<template>
  <div class="reward-list-page">
    <div class="reward-list-shell">
      <header class="reward-list-header">
        <button class="reward-list-back" type="button" :aria-label="$t('prizesBack')" @click="back">
          <img src="../../static/images/prizes/back.png" alt="" />
        </button>
        <h1>{{$t('claimRewardListTitle')}}</h1>
      </header>
      <main class="reward-list-content">
        <div v-if="rewards.length" class="reward-list">
          <div class="reward-list-row reward-list-head">
            <span>{{$t('claimRewardExpiry')}}</span>
            <span>{{$t('claimRewardAmount')}}</span>
            <span>{{$t('claimRewardAction')}}</span>
          </div>
          <div class="reward-list-row reward-list-item" v-for="item in rewards" :key="item.id">
            <span class="app-en">{{formatExpiration(item.claim_expire_time)}}</span>
            <span class="app-en reward-list-amount">{{item.traffic_mb}} MB</span>
            <button class="reward-claim-btn" type="button" :disabled="claimingRewardId === item.id" @click="claimReward(item)">
              {{$t('claimRewardAction')}}
            </button>
          </div>
        </div>
        <div class="reward-list-empty" v-else-if="loaded">{{$t('claimRewardEmpty')}}</div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rewards:[],
      loaded:false,
      claimingRewardId:null
    }
  },
  created(){
    this.getRewards()
  },
  methods:{
    back(){
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({path:'/'})
      }
    },
    getRewards(){
      let that = this
      that.$api.post('/api/traffic_reward/index',null,r =>{
        that.$parent.returnCode(r,function(){
          that.rewards = r.data && r.data.list ? r.data.list : []
          that.loaded = true
        })
      })
    },
    claimReward(reward){
      let that = this
      if (that.claimingRewardId) {
        return
      }
      that.claimingRewardId = reward.id
      that.$parent.loadModal(true)
      that.$api.post('/api/traffic_reward/claim',{reward_id:reward.id},r =>{
        that.$parent.loadModal(false)
        that.claimingRewardId = null
        that.$parent.returnCode(r,function(){
          that.$utils.alertText(that.$t('claimRewardSuccess'),80)
          that.getRewards()
        })
      },() => {
        that.$parent.loadModal(false)
        that.claimingRewardId = null
        that.$utils.alertText(that.$t('claimRewardNetworkError'),80)
      })
    },
    formatExpiration(expiration){
      return expiration ? expiration.slice(5,16) : '-'
    }
  }
}
</script>

<style scoped>
.reward-list-page{width:100%;min-height:100vh;background:#080e36 url(../../static/images/index/main_bg.jpg) no-repeat center top;background-size:100% 100%;color:#fff;font-family:Atom-sans;}
.reward-list-shell{width:100%;max-width:7.5rem;min-height:100vh;margin:0 auto;padding:0.68rem 0.26rem 0.5rem;}
.reward-list-header{position:relative;min-height:1.1rem;display:flex;align-items:center;justify-content:center;padding:0 0.9rem;text-align:center;}
.reward-list-header h1{margin:0;font-family:Atom-sans-bold;font-size:0.46rem;line-height:1.15;text-shadow:0 0 0.24rem #824dff;overflow-wrap:anywhere;}
.reward-list-back{position:absolute;top:50%;left:0.05rem;width:0.72rem;height:0.72rem;padding:0;border:0;background:none;transform:translateY(-50%);cursor:pointer;}
.reward-list-back img{display:block;width:100%;height:100%;}
.reward-list-content{min-height:2rem;margin:0.32rem auto 0;padding:0.2rem 0.16rem 0.3rem;border:0.02rem solid rgba(54,189,239,0.56);border-radius:0.28rem;background:linear-gradient(145deg,rgba(9,15,62,0.92),rgba(15,31,92,0.82));box-shadow:0 0.14rem 0.45rem rgba(0,0,44,0.3);}
.reward-list-row{display:grid;grid-template-columns:minmax(0,1.35fr) minmax(0,0.75fr) minmax(0,0.85fr);gap:0.07rem;align-items:center;padding:0.14rem 0.09rem;text-align:center;overflow-wrap:anywhere;}
.reward-list-head{min-height:0.78rem;border-radius:0.18rem;background:linear-gradient(180deg,#314bca,#132474);font-family:Atom-sans-bold;font-size:0.22rem;line-height:1.15;}
.reward-list-item{min-height:1.06rem;border-bottom:0.02rem solid rgba(87,175,235,0.28);font-size:0.24rem;line-height:1.2;}
.reward-list-item:last-child{border-bottom:0;}
.reward-list-amount{color:#a6ff38;font-family:Atom-sans-bold;}
.reward-claim-btn{min-width:0;min-height:0.54rem;padding:0.06rem 0.08rem;border:0.02rem solid #d9faff;border-radius:0.35rem;background:linear-gradient(180deg,#36d9ff,#2258e5 66%,#6b4dff);box-shadow:0 0.04rem 0.13rem rgba(34,188,255,0.55);color:#fff;font-family:Atom-sans-bold;font-size:0.22rem;line-height:1.15;cursor:pointer;overflow-wrap:anywhere;}
.reward-claim-btn:disabled{opacity:0.65;cursor:default;}
.reward-list-empty{padding:0.72rem 0.2rem;color:#fff;font-size:0.3rem;line-height:1.4;text-align:center;}
@media (min-width:481px){.reward-list-page{box-shadow:0 0 0 100vmax #0d123b;}}
</style>



// WEBPACK FOOTER //
// src/page/trafficReward.vue